<template>
  <section class="color-new-light-grey">
    <v-container :class="{ 'pa-0': this.$vuetify.breakpoint.smAndDown }">
      <v-row>
        <v-col cols="12">
          <h1 class="text-h1 text-center">{{ $t('pe-text-1') }}</h1>
        </v-col>
      </v-row>
      <v-row :class="{ 'no-gutters': this.$vuetify.breakpoint.smAndDown }">
        <v-col cols="12">
          <v-card>
            <v-card-text class="px-0">
              <v-col cols="12" class="text-center">
                <p class="grey--text">{{ $t('pe-text-3') }}</p>
              </v-col>
              <v-data-table v-model="selected"
                            :headers="headers"
                            :items="debts"
                            item-key="orderNr"
                            hide-default-footer
                            show-select
                            :items-per-page="-1"
                            :mobile-breakpoint=0
                            data-matomo-mask>
                <template #item.receiver>
                  B2 Impact
                </template>
                <template #item.debtSummary.total="{ item }">
                  {{ item.debtSummary.total | currency }}
                </template>
                <template #item.debtSummary.left="{ item }">
                  {{ item.debtSummary.left | currency }}
                </template>
                <template slot="footer">
                  <v-container class="pb-0">
                    <v-row no-gutters justify="space-around">
                      <div>
                        <div class="grey--text">{{ $t('pe-text-5') }}<b> {{ selected.length }} {{ $t('kpl') }}</b></div>
                        <div class="grey--text">{{ $t('amountToPay') }}<b> {{ selectedTotal | currency }}</b></div>
                      </div>
                      <v-btn tile color="primary" @click="setPaymentData" :disabled="hidePaymentButtons || (selected !== null && selected.length === 0)" class="payment-button payment-button-all">{{ $t('continueToPay') }}</v-btn>
                    </v-row>
                  </v-container>
                </template>
              </v-data-table>
              <v-dialog v-if="$vuetify.breakpoint.smAndDown"
                        v-model="mobilePaymentDialog"
                        fullscreen
                        hide-overlay
                        transition="dialog-bottom-transition"
                        content-class="payment-dialog"
                        scrollable>
                <shared-payment-forms :paymentData="paymentData" @cancelled="cancelled"></shared-payment-forms>
              </v-dialog>
              <shared-payment-forms v-else :paymentData="paymentData" @cancelled="cancelled"></shared-payment-forms>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  export default {
    data: function () {
      return {
        paymentData: [],
        hidePaymentButtons: false,
        mobilePaymentDialog: false,
        selected: [],
        receiver: "B2 Impact"
      }
    },
    methods: {
      setPaymentData () {
        let payments = []

        if (this.$vuetify.breakpoint.smAndDown) {
          this.mobilePaymentDialog = true
        } else {
          this.mobilePaymentDialog = false
        }
        this.hidePaymentButtons = true

        for (let i = 0; i < this.selected.length; i++) {
          let debt = this.selected[i]
          if (debt.debtSummary.left > 0) {
            payments.push({
              debtNr: debt.orderNr,
              description: debt.creditor.name,
              amount: debt.debtSummary.left,
              msnr: null,
              paymentType: 'multiple'
            })
          }
        }

        this.paymentData = payments
        this.$matomo && this.$matomo.trackEvent("Payment", "Payment", "Payment Multiple Start")
      },
      cancelled () {
        this.hidePaymentButtons = false
        this.mobilePaymentDialog = false
        this.paymentData = null
      }
    },
    mounted () {
      if (this.debts.length === 0) {
        this.$router.push('/front-page')
      }
    },
    computed: {
      debts () {
        let debts = this.$store.getters.openDebts
        this.selected = debts
        return debts
      },
      headers () {
        let desktopHeaders = [
          {
            text: '',
            align: 'start',
            sortable: false,
            value: '',
          },
          { text: this.$t('debt'), value: 'nr' },
          { text: this.$t('amountToPay'), value: 'debtSummary.left' },
          { text: this.$t('debtAmount'), value: 'debtSummary.total' },
          { text: this.$t('creditor'), value: 'creditor.name' },
          { text: this.$t('paymentReceiver'), value: 'receiver' }
        ]

        let mobileHeaders = [
          { text: this.$t('creditor'), value: 'creditor.name' },
          { text: this.$t('amountToPay'), value: 'debtSummary.left' }
        ]

        return this.$vuetify.breakpoint.smAndDown ? mobileHeaders : desktopHeaders
      },
      selectedTotal () {
        let unpaid = 0
        for (let i = 0; i < this.selected.length; i++) {
          unpaid += this.selected[i].debtSummary.left
        }
        return unpaid
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "pe-text-1": "Maksa velkojasi kertamaksulla",
  "pe-text-3": "Alla näet yhteenvedon veloistasi:",
  "pe-text-4": "Avoinna yhteensä",
  "pe-text-5": "Valittuja velkoja"
  },
  "se": {
  "pe-text-1": "Betala dina skulder med en betalning",
  "pe-text-3": "Här under kan du se en sammanfattning av dina skulder:",
  "pe-text-4": "Obetalt totalt",
  "pe-text-5": "Valda skulder"
  },
  "en": {
  "pe-text-1": "Pay your debts with one payment",
  "pe-text-3": "Below you can see a summary of your debts:",
  "pe-text-4": "Unpaid amount",
  "pe-text-5": "Selected debts"
  }
  }
</i18n>
